// extracted by css-extract-rspack-plugin
export default {"toggleSwitchWrapper":"toggleSwitchWrapper-m5EjUN"};